import { classNames } from 'primereact/utils';

export const PTTooltip = {
  root: ({ context }) => {
    return {
      className: classNames(
        'absolute bg-black/90 backdrop-blur-sm color-white rounded-lg max-w-100',
        {
          'py-0 px-1':
            context.right ||
            context.left ||
            (!context.right &&
              !context.left &&
              !context.top &&
              !context.bottom),
          'py-1 px-0': context.top || context.bottom,
        },
      ),
    };
  },
  arrow: ({ context }) => ({
    className: classNames('absolute w-0 h-0 border-transparent border-solid', {
      '-mt-1 border-y-[0.25rem] border-r-[0.25rem] border-l-0 border-r-green-5':
        context.right,
      '-mt-1 border-y-[0.25rem] border-l-[0.25rem] border-r-0 border-l-green-5':
        context.left,
      '-ml-1 border-x-[0.25rem] border-t-[0.25rem] border-b-0 border-t-green-5':
        context.top,
      '-ml-1 border-x-[0.25rem] border-b-[0.25rem] border-t-0 border-b-green-5':
        context.bottom,
    }),
  }),
  text: {
    className:
      'px-3 py-2 text-white rounded-lg whitespace-pre-line break-words shadow-md',
  },
};
